<template>
  <div>
    <el-select v-model="companyFeeAttributeId"
               placeholder="请选择"
               :clearable="true"
               @change="selectChange"
    >
      <el-option v-for="item in options"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'companyFeeAttributeSelect',
  props: {
    companyFeeAttributeId: {
      required: true,
      type: [String, Number]
    }
  },
  data() {
    return {
      options: [],
    }
  },
  mounted() {
    this.loadSnCompanyFeeAttribute()
  },
  methods: {
    selectChange() {
      this.$emit('update:companyFeeAttributeId', this.companyFeeAttributeId)
    },

    //初始化加载费用名称
    loadSnCompanyFeeAttribute() {
      this.$http.get('/admin/snCompanyFeeAttribute/list', {}).then(res => {
        this.options = [];
        res.data.data.forEach(item => {
          this.options.push({
            label: item.attributeName,
            value: item.id
          })
        })
      });
    },

  }
}
</script>

<style scoped lang="scss">

</style>
